const getters = {
  isLoggedIn(state) {
    return state.isLoggedIn;
  },

  userEmail(state) {
    return state.user.email;
  },

  isAdmin: (state) => (companyId) => {
    return state.user.companies[companyId].role.role_name === 'admin';
  },

  hasPermission: (state) => (projectId, permission) => {
    return (
      state.user.projects[projectId] !== undefined &&
      state.user.projects[projectId].permissions[permission]
    );
  },
};

export default getters;
